import React, { Component } from 'react';
import AppButton from './AppButton';
import { Address } from './Address'
import queryString from 'query-string'
import AuthService from "../services/AuthService";
import './AdditionalServices.scss';
import ConfigService from "../services/ConfigService";
import UtilService from "../services/UtilService";

export class AdditionalServices extends Component {
    static displayName = AdditionalServices.name;

    constructor(props) {
        super(props);
        const { match: { params, search } } = this.props;
        this.state = {
            notFound: false,
            shipment: {
                connote: "",
                status: 0,
                from: {},
                to: {},
                additionalServices: []
            },
            offer: {
                offers: [{}]
            },
            config: {
                termsAndConditions: {
                    // default but will be overriden by config
                    additionalServicesUrl: "http://www.fliway.com/media/5413/fliway-termsandconditions-dec17.pdf"
                }
            },           
            acceptTerms: false,
            params: params || {jobid: null},
            busy: true
        };
    }

    async componentDidMount() {                
        const qs = queryString.parse(this.props.location.search);  
        var offerTask = this.loadOffer();        
        let configTask = ConfigService.getConfig();
        await offerTask;        
        let config = await configTask;
        this.setState({loaded: true, config: {...this.state.config, ...config}});  
        this.loadServices(qs.s);
        this.authService = await AuthService.getInstance();
    }

    visibleAdditionalServices = () => {
        let map = this.state.config?.maps?.availableUntilToShipmentStatus; 
        return this.state.shipment?.additionalServices?.filter(svc => {
            if(svc.selected && svc.paid_by)
                return true;
            else if(svc.selected === false){
                // and the shipment is in a state which allows selecting of this additional service
                let matchingMap = map.find(m=>m.until===svc.available_until);
                console.log('matching map for service',svc, matchingMap);
                if(matchingMap?.states.some(s=>s===this.state.shipment.status))
                    return true;
            }
            return false;
        });
    }

    loadServices = () => {
        let services = this.visibleAdditionalServices();
        this.setState({shipment: {...this.state.shipment, additionalServices: services, acceptTerms: true}});
    }

    async loadOffer() {
        let offer;
        if(this.state.params.jobid === "testing") 
            offer = {shipment: {
                connote: "TESTING",
                from: { line1: "Fliway Internal Billing" },
                to: { line1: "Quentin Bennett", line2: "77 Westney Road", line3: "Mangere"}
            },
            offer: {
                offers: [{start_time: new Date()}],
            }
        };        
        else
            offer = await (await window.fetch('api/offer/' + this.state.params.jobid)).json();
        this.setOffer(offer);
        this.setState({busy: false});
        return offer;
    }

    startPayment = async () => { 
        // check if we're logged in
        let user;
        try{
            user = await this.authService.getAuthenticatedUser(true);
        }
        catch(err) {
            console.error('Please login (or register) to do this.');
            return;
        }

        // at least one service must be selected that's not already paid
        if(this.state.shipment.additionalServices.reduce((sum, service) => sum + (service.selected === true && !service.justpaid && !service.paid_by ? 1 : 0),0) <= 0){
            alert("Please select at least one service");
            return;
        }
        
        if(this.state.acceptTerms !== true){
            alert("Please accept T&Cs before paying");
            return;
        }
        const paymentDetails = await this.postData('api/offer/' + this.state.params.jobid + '/startpayment', {shipment: this.state.shipment, isRedirect: false}, user.access_token);
        if(paymentDetails) {
            console.log('payment page details', paymentDetails);
            window.location.href = paymentDetails.paymentPageUrl;
        }
    }

    changeAdditionalService = (selectedCode) => {
        this.setState({
            // Don't mutate state
            shipment: {...this.state.shipment, additionalServices: this.state.shipment.additionalServices.map(as => ({
                ...as,
                // Toggle the one that's been clicked  
                selected: (as.code === selectedCode) ? !as.selected : as.selected
            }))}            
        });
    }

    toggleTCs = () => {
        this.setState({
            acceptTerms: !this.state.acceptTerms
        });
    }

    totalPrice = () =>  {       
        var total = this.state.shipment.additionalServices.reduce((sum, service) => sum + (service.selected === true && !service.justpaid && !service.paid_by ? parseFloat(service.priceInclGST)||0 : 0.0),0.0);
        return `$${UtilService.roundMoneyTo(total, 2)}`;    
    }

    setOffer(newOffer) {
        //console.log('offer details', newOffer);
        if (newOffer.location){
            this.setState({location: newOffer.location});
        }
        if (newOffer.shipment){
            this.setState({shipment: newOffer.shipment});
        }
        if (newOffer.offer){
            this.setState({offer: newOffer.offer});
        }
        else if (newOffer.status === 404) {
            this.setState({
                notFound: true
            });
        }
    }

    postData(url = '', data = {}, idToken = null) {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        if(idToken)
            headers.append('Authorization', `Bearer ${idToken}`);

        return fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: headers,
            redirect: 'follow',
            referrer: 'no-referrer',
            body: JSON.stringify(data),
        })
        .then(response => {
            if(!response.ok) {
                if(response.status == "409"){
                    alert("Sorry this is out of date; Tap to refresh.");
                    return this.loadOffer();
                }
                if(response.status == "401"){
                    alert("Please login or register to do this.");
                    return null;
                }
                else{
                    alert("Error: " + response.statusText);
                }
            }
            return response.json();
        });
    }

    render() {

        var hasAvailableSelection = this.state.shipment.additionalServices.some((as) => !as.justpaid && !as.paid_by);

        return (
            this.state.notFound === true ?
            <div>
                <div className="header">My Delivery: NOT FOUND</div>
                <div style={{textAlign: "center"}}>Shipment Not Found</div>
            </div> :
                <div className="additional-services">
                    <div className="header">My Delivery: ADDITIONAL SERVICES</div>
                    {this.state.busy && <div>Loading...</div>}
                    {!this.state.busy &&
                    <div>
                    <div className="view-body">    
                        <div className="edit-icon-right">                              
                            <Address label="We have a parcel for you from" address={{line1: this.state.shipment.from.line1}} />
                            <div><i className="icon-x-app-icon connote"></i></div>
                        </div>
                        <Address label="Your delivery address" address={this.state.shipment.to} />                    
                        <div>
                            <div style={{marginTop: "0.4em"}} />
                            <div className="header">Additional Services</div>                        
                            <table className="services">
                                <tbody>
                                    {this.state.shipment.additionalServices.map((as) => 
                                        <tr key={as.code}>
                                            <td><input type="checkbox" className="large" defaultChecked={as.selected} disabled={(as.justpaid === true || as.paid_by)} onClick={() => this.changeAdditionalService(as.code)}/></td>
                                            <td style={{width: "100%"}}>{as.description}</td>
                                            <td>{(as.priceInclGST !== null && !as.paid_by && !as.justpaid) && '$' + UtilService.roundMoneyTo(parseFloat(as.priceInclGST||0.0), 2)}</td>
                                        </tr>)}
                                        {hasAvailableSelection &&
                                            <tr>
                                                <td><input type="checkbox" className="large" checked={this.state.acceptTerms} onChange={() => this.toggleTCs()} /></td>
                                                <td className="tcsLink" colSpan="2">
                                                    Acceptance of Additional Services <a style={{ whiteSpace: "nowrap" }} href={this.state.config.termsAndConditions.additionalServicesUrl} target="_blank">Terms &amp; Conditions</a>
                                                    <div className="contactus"><a target="_blank" href={this.state.config.contactUsUrl}>{this.state.config.contactUsText}</a></div>
                                                </td>
                                            </tr>
                                        }
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <div className="header">Total Price (incl. GST)<div style={{float: "right"}}>{this.totalPrice()}&nbsp;</div></div>
                        </div>
                        <div className="action-area">
                            <div className="clearfix">
                              {hasAvailableSelection && <React.Fragment>
                                {this.totalPrice() !== "$0.00" ?
                                  <AppButton ajaxInProgress={this.props.busy}  iconName="icon-button-credit-card" footer="Tap here to proceed to payment" actionText="Pay Now" onClick={this.startPayment}/> :
                                            <AppButton ajaxInProgress={this.props.busy} iconName="icon-button-tick" footer="Tap here to confirm selections &nbsp; &nbsp;" actionText="Confirm" onClick={this.startPayment} />}
                              </React.Fragment>}
                              <AppButton function iconName="icon-function-left-arrow-up" actionText="Back" 
                                  onClick={() => { this.props.history.push(`../../${(this.state.offer.status ==="Accepted" || this.state.offer.status ==="Contact" || this.state.shipment.status === 'OFD' || this.state.shipment.status === 'OFDOffSchedule' || this.state.shipment.status === 'Delivered') ? 'o': 'ao'}/` + this.state.params.jobid)  }} footer="Return to options"/>
                            </div>
                        </div>
                    </div>
                </div>}
            </div>
        );
    }
}
